export const enum URLEnums {
  PrivacyPolicy = '/privacy-notice',
  PrivacyPolicyMain = '/privacy-notice#main-dif',
  PrivacyPolicyCookie = '/privacy-notice#cookie-dif',
  Thanks = '/thanks',
  ContactUs = '/contact-us',
}
